/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum AccessOutcome {
  HasAccessWithData = "HasAccessWithData",
  HasAccessNoData = "HasAccessNoData",
  NoAccess = "NoAccess",
}

export function AccessOutcomeFromJSON(json: any): AccessOutcome {
  return AccessOutcomeFromJSONTyped(json, false);
}

export function AccessOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessOutcome {
  return json as AccessOutcome;
}

export function AccessOutcomeToJSON(value?: AccessOutcome | null): any {
  return value as any;
}
